// Card media lives in public/media/projects and is generated by scripts/build-media.sh.
// `image` is a static screenshot; `video` is a short looping clip with its own poster.
const media = (slug) => ({ webp: `/media/projects/${slug}.webp`, src: `/media/projects/${slug}.jpg` });
const clip = (slug, { webm = true } = {}) => ({
  sources: [
    ...(webm ? [{ src: `/media/projects/${slug}.webm`, type: 'video/webm' }] : []),
    { src: `/media/projects/${slug}.mp4`, type: 'video/mp4' },
  ],
  poster: `/media/projects/${slug}-poster.jpg`,
  posterWebp: `/media/projects/${slug}-poster.webp`,
});

export const projects = [
  {
    id: 'atlantic',
    title: 'Atlantic Companies',
    description:
      'Built and maintain the marketing site for Atlantic Companies, now averaging around 4,000 visitors a month. Integrated custom data pipelines and analytics to track visitor behavior alongside SEO optimization to grow organic search traffic.',
    tech: ['Next.js', 'React', 'Vercel', 'Data Pipelines', 'Analytics', 'SEO Optimization'],
    link: 'https://smarthome.biz',
    image: media('atlantic'),
  },
  {
    id: 'foyer',
    title: 'Foyer',
    description:
      'A simple test site I made to get better at designing in a SaaS style for a more commercial software product with multiple functions. Foyer is a concept partner relationship management platform, with a partner dashboard, deal registration, lead routing with SLAs, and a light and dark theme.',
    tech: ['Next.js', 'React', 'Vercel', 'UI/UX Design'],
    link: 'https://foyer-two-pi.vercel.app',
    image: media('foyer'),
  },
  {
    id: 'cfas',
    title: 'Central Florida Automation',
    description:
      'Currently building this site for a Central Florida smart-home integration and security company serving the Orlando area. Designing a clean, high-end marketing site that highlights their automation, surveillance, lighting control, and AV services while reflecting the premium, invisible-technology feel of their luxury residential work. (Work in progress.)',
    tech: ['Next.js', 'React', 'Vercel'],
    link: 'https://cfalarm.com',
    video: clip('cfas', { webm: false }),
  },
  {
    id: 'mandel',
    title: 'Mandel Moving',
    description:
      'Built and launched a professional marketing website end-to-end for Mandel Moving (NJ), handling everything from design system creation to production deployment. Focused on clean UI, fast load performance, and a conversion-first layout designed to drive service inquiries and establish credibility in a competitive local market.',
    tech: ['Next.js', 'React', 'SEO Optimization'],
    link: 'https://mandelmoving.com',
    image: media('mandel'),
  },
  {
    id: 'lumavalen',
    title: 'Luma Valen',
    description:
      'Built the official website for recording artist Luma Valen, bringing her music, videos, and merch together under one cinematic, star-field visual identity. Includes streaming links, an upcoming merch collection, and a newsletter signup to grow her fan list.',
    tech: ['Next.js', 'React', 'Vercel'],
    link: 'https://luma-valen-site.vercel.app',
    image: media('lumavalen'),
  },
  {
    id: 'gpp',
    title: 'Guided Peak Potential',
    description:
      'Developed a professional website for my mom who needed to filter her clients through one place providing an ease of communication to allow for seamless scheduling and ease of purchase for her clients',
    tech: ['React', 'Javascript', 'HTML/CSS'],
    link: 'https://gpppartnersgroup.com/',
    video: clip('gpp', { webm: false }),
  },
  {
    id: 'drakesites',
    title: "Drake's Sites",
    description:
      'Built my own web development business site to move beyond a general personal portfolio and speak directly to potential clients. Wanted something niche-focused, a site that leads with what I offer, who I build for, and why it matters, rather than an overview of me as a person.',
    tech: ['Next.js', 'React', 'Vercel', 'Tailwind CSS'],
    link: 'https://drakesites.dev',
    video: clip('drakesites'),
  },
  {
    id: 'flickfinda',
    title: 'AI-Powered Movie Selector',
    description:
      'Designed a cloud native movie selection platform to minimize the time it takes to select a title for movie night. Make an account or browse as a guest if you would like to check out my work',
    tech: ['Javascript', 'Python', 'SQL', 'HTML/CSS', 'API Integration', 'Credential Managment'],
    link: 'https://www.flickfinda.com',
    image: media('flickfinda'),
  },
  {
    id: 'trinnav',
    title: 'TrinNav',
    description:
      'Senior capstone iOS app — a graph-driven campus navigation system for Trinity College. Built with SwiftUI, MapKit, and SceneKit to deliver panoramic 360° views at each node, real-time route resolution across a custom JSON node topology, and CoreLocation-based positioning. Not publicly hosted; click to view the full project description.',
    tech: ['Swift', 'SwiftUI', 'MapKit', 'SceneKit', 'AVFoundation', 'CoreLocation', 'Xcode'],
    modal: true,
    image: media('trinnav'),
    // Shown as an app, not a site: real screens in phone frames over a blurred map.
    screens: [media('trinnav'), media('trinnav-360')],
    backdrop: media('trinnav-bg'),
  },
];
